import React, { createContext, useContext, useState } from 'react';

interface ErrorReportContextType {
  isModalOpen: boolean;
  openModal: () => void;
  closeModal: () => void;
}

const ErrorReportContext = createContext<ErrorReportContextType | undefined>(undefined);

export const useErrorReport = () => {
  const context = useContext(ErrorReportContext);
  if (context === undefined) {
    throw new Error('useErrorReport must be used within an ErrorReportProvider');
  }
  return context;
};

export const ErrorReportProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  return (
    <ErrorReportContext.Provider value={{ isModalOpen, openModal, closeModal }}>
      {children}
    </ErrorReportContext.Provider>
  );
};